import { openingTimeTableUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'

async function getOpeningTimesFromRestaurant() {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${openingTimeTableUrl}/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.openingTimeTable });
    return data;
}

async function updateOpeningTime(label, data) {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    data.restaurantId = restaurantid;
    let url = `${openingTimeTableUrl}/${restaurantid}/${label}`;
    await common.putData(url, data)
                .catch(err => console.log(err));
}

async function getCurrentWaitingTimeByRestaurant(id) {
    let restaurantid = id;
    let url = `${waitingtimesUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response });
    return data;
}



export default {
    name: 'openingTimesService',
    getOpeningTimesFromRestaurant,
    getCurrentWaitingTimeByRestaurant,
    updateOpeningTime
} 